import $ from 'jquery';
import Swiper from "swiper";
import { A11y,  EffectFade, Autoplay } from "swiper/modules";
const AnimateBackground = (el) => {
    let $el = $(el);


    if ($el.length === 0) {
        console.warn("Element not found for Swiper initialization");
        return;
    }

    let swiper = new Swiper($el[0], {
        modules: [A11y, EffectFade, Autoplay],
        speed: 600,
        spaceBetween: 100,
        loop: true,
        effect: "fade",
        fadeEffect: {
            crossFade: true
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        },
    } );

};


export default AnimateBackground;
